import { render, staticRenderFns } from "./BizExpeditingList.vue?vue&type=template&id=6636cde3&scoped=true"
import script from "./BizExpeditingList.vue?vue&type=script&lang=js"
export * from "./BizExpeditingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6636cde3",
  null
  
)

export default component.exports